var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"upload-status"},[_vm._v("\n\t"+_vm._s(_vm.status)+"\n\t"),(_vm.statusMessage)?_c('help-icon',{attrs:{"content":_vm.statusMessage}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }